import { t } from '@lingui/core/macro'

interface Props {
  options: { label: string; value: string }[]
  value: string
  onChange: (event: React.ChangeEvent<HTMLSelectElement>) => void
}

export const Sort = ({ options, value, onChange }: Props) => (
  <div className="flex items-center space-x-2">
    <span>{t`Sorted by:`}</span>
    <select
      className="appearance-none bg-transparent border-none focus:outline-none underline hover:cursor-pointer"
      value={value}
      onChange={onChange}
    >
      {options.map(option => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  </div>
)
